
import { defineComponent } from 'vue';

export default defineComponent({
    props: ['title', 'notifications', 'id', 'callback', 'current']
});
